import { Injectable } from '@angular/core';
import { DocumentService, UserService } from '@app/shared/services';
import { ChecklistService } from '@app/shared/services/checklist/checklist.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import * as checklistActions from './actions';

@Injectable()
export class ChecklistStoreEffects {
  constructor(private checklistService: ChecklistService, private actions$: Actions) {}


  //  getChecklists$: Observable<any> = this.actions$.pipe(
  //   ofType<checklistActions.GetChecklistRequestAction>(checklistActions.ActionTypes.GET_CHECKLIST),
  //   switchMap(({ payload }) => {
  //     return this.checklistService.getCheckLists(payload.id).pipe(
  //       map((data) => {
  //         return new checklistActions.GetChecklistSuccessAction(data);
  //       }),
  //       catchError((error) => {
  //         return of(new checklistActions.GetChecklistSuccessAction(error));
  //       })
  //     );
  //   })
  // );


  getChecklists$: Observable<any> = createEffect(() =>
  this.actions$.pipe(
    ofType<checklistActions.GetChecklistRequestAction>(checklistActions.ActionTypes.GET_CHECKLIST),
    switchMap(({ payload: payload }) =>
      this.checklistService.getCheckLists(payload.id).pipe(
        map((data) => new checklistActions.GetChecklistSuccessAction({ data })),
        catchError((error) => of(new checklistActions.GetChecklistFailureAction({ error })))
      )
    )
  )
);



}
